import {Button} from "primereact/button";
import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from "primereact/inputtextarea";
import {Calendar} from "primereact/calendar";
import { ProgressSpinner } from 'primereact/progressspinner';
import {endpoints} from "../constants/env/middletier";

export default function AddProjectForm({ formVisible, setFormVisible }) {
    const [loading, setLoading] = useState(false);

    const handleNewClientSubmit = async (e) => {
        console.log('Form values:', client);
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(Endpoints["client"], {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(client),
            });

            const result = await response.json();
            console.log("Success:", result);
            clearFormValues();
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };

    const clearFormValues = (e) => {
        setClient({
            name: '',
            abbreviation: '',
            type: '',
            phone: '',
            description: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: 'US'
        });
    }

    const [client, setClient] = useState({
        name: 'General Services Administration',
        abbreviation: 'GSA',
        type: 'Project Management',
        phone: '123-678-1017',
        description: 'This is a well known government entity',
        address1: '123 A St',
        address2: 'A16',
        city: 'Springville',
        state: 'IA',
        zip: '32145',
        country: 'US'
    });

    // const statusOptions = [
    //     { label: 'In Progress', value: 'In Progress' },
    //     { label: 'Pending', value: 'Pending' },
    //     { label: 'Completed', value: 'Completed' }
    // ];
    //
    // const cxTypeOptions = [
    //     { label: 'New Building Commission', value: 'New Building Commission' },
    //     { label: 'Retro Commission', value: 'Retro Commission' },
    //     { label: 'Recommissioning', value: 'Recommissioning' }
    // ];
    //
    // const timezoneOptions = [
    //     { label: 'Eastern', value: 'eastern' },
    //     { label: 'Central', value: 'central' },
    //     { label: 'Mountain', value: 'mountain' },
    //     { label: 'Pacific', value: 'pacific' }
    // ];

    const updateField = (field, value) => {
        setClient((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    return (
    <>
        <div className="card">
            <Dialog header="Add Client" visible={formVisible} style={{ width: '90vw' }}
                    breakpoints={{
                        '960px': '95vw',
                        '640px': '100vw'
                    }}
                    maximizable
                    modal onHide={() => setFormVisible(false)}>


                <div className="grid formgrid p-fluid">

                    <div className="field col-12 md:col-4">
                        <label htmlFor="name">Client Name</label>
                        <InputText
                            id="name"
                            value={client.name}
                            onChange={(e) => updateField('name', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="abbreviation">Abbreviation</label>
                        <InputText
                            id="abbreviation"
                            value={client.abbreviation}
                            onChange={(e) => updateField('abbreviation', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="type">Type</label>
                        <InputText
                            id="type"
                            value={client.type}
                            onChange={(e) => updateField('type', e.target.value)}
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="phone">Phone</label>
                        <InputText
                            id="phone"
                            value={client.phone}
                            onChange={(e) => updateField('phone', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="address1">Address 1</label>
                        <InputText
                            id="address1"
                            value={client.address1}
                            onChange={(e) => updateField('address1', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="address2">Address 2</label>
                        <InputText
                            id="address2"
                            value={client.address2}
                            onChange={(e) => updateField('address2', e.target.value)}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="city">City</label>
                        <InputText
                            id="city"
                            value={client.city}
                            onChange={(e) => updateField('city', e.target.value)}
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="state">State</label>
                        <InputText
                            id="state"
                            value={client.state}
                            onChange={(e) => updateField('state', e.target.value)}
                        />
                    </div>


                    <div className="field col-12 md:col-4">
                        <label htmlFor="zip">Zip</label>
                        <InputText
                            id="zip"
                            value={client.zip}
                            onChange={(e) => updateField('zip', e.target.value)}
                        />
                    </div>

                    <div className="field col-12">
                        <label htmlFor="description">Description</label>
                        <InputTextarea
                            id="description"
                            rows={5}
                            value={client.description}
                            onChange={(e) => updateField('description', e.target.value)}
                        />
                    </div>
                    {loading ? ( <ProgressSpinner /> ) : ( <div></div> )}

                    <div className="field col-12 md:col-10">

                    </div>
                    <div className="field col-12 md:col-2">
                        <Button
                            type="submit"
                            label="Save Client"
                            icon="pi pi-save"
                            severity="info"
                            onClick={handleNewClientSubmit}
                        />
                    </div>

                </div>
            </Dialog>
        </div>

    </ >
);
}